import React from 'react';
import { Alert, Form, Modal, Space, Switch, Typography, message } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
const { Text } = Typography;

const ModalPuntoDeVentaPos = ({ isModalPosOpen, setIsModalPosOpen, formPos, configLoading, updateConfig }) => {
    return (
        <Modal
            title={
                <Space size="middle" align="center">
                    <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '12px', display: 'flex' }}>
                        <SettingOutlined style={{ color: '#475569', fontSize: '22px' }} />
                    </div>
                    <span style={{ fontSize: '20px', fontWeight: '900', color: '#0f172a' }}>Punto de Venta</span>
                </Space>
            }
            open={isModalPosOpen}
            onCancel={() => setIsModalPosOpen(false)}
            onOk={() => formPos.submit()}
            confirmLoading={configLoading}
            centered
            width={550}
            className="modal-pos-yugonub"
            cancelText="CANCELAR"
            cancelButtonProps={{ style: { height: '45px', borderRadius: '10px', fontWeight: '600', padding: '0 20px' } }}
            okText="GUARDAR"
            okButtonProps={{ style: { backgroundColor: '#22BABB', height: '45px', borderRadius: '10px', fontWeight: 'bold', border: 'none', padding: '0 25px' } }}
            styles={{ body: { paddingTop: '15px' } }}
        >
            {/* Estilos forzados para arreglar el contraste del Switch */}
            <style>{`
                .modal-pos-yugonub .ant-switch {
                    background-color: #94a3b8 !important; /* Gris oscuro para estado Inactivo */
                    min-width: 65px; /* Ancho ajustado para "Sí" y "No" */
                }
                .modal-pos-yugonub .ant-switch-checked {
                    background-color: #0ea5e9 !important; /* Azul para estado Activo */
                }
                .modal-pos-yugonub .ant-switch-inner {
                    color: #ffffff !important;
                    font-weight: 600;
                    font-size: 13px;
                }
            `}</style>

            <Form form={formPos} layout="vertical" onFinish={async (values) => {
                try {
                    await updateConfig({ permitir_edicion_precios: values.permitir_edicion_precios ? 'true' : 'false' });
                    message.success('Configuración del POS guardada');
                    setIsModalPosOpen(false);
                } catch (error) { message.error('Error al guardar la configuración'); }
            }}>
                <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '16px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', paddingRight: '20px' }}>
                        <Text strong style={{ fontSize: '16px', color: '#0f172a', marginBottom: '4px' }}>Edición manual de precios</Text>
                        <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.4' }}>Permitir cambiar el precio de un producto directamente desde el carrito de ventas del POS.</Text>
                    </div>
                    <Form.Item name="permitir_edicion_precios" valuePropName="checked" noStyle>
                        <Switch checkedChildren="Sí" unCheckedChildren="No" />
                    </Form.Item>
                </div>

                <Alert
                    style={{ marginTop: '20px', borderRadius: '12px', border: '1px solid #bae6fd', padding: '12px 16px' }}
                    type="info"
                    showIcon
                    message={<Text strong style={{ color: '#0369a1', fontSize: '14px' }}>Aviso de Permisos</Text>}
                    description={<Text style={{ color: '#0c4a6e', fontSize: '13px' }}>Aunque actives esto a nivel global, solo los usuarios que tengan el permiso <b>'Editar precios en POS'</b> en su Rol podrán usar la función.</Text>}
                />
            </Form>
        </Modal>
    )
}

export default ModalPuntoDeVentaPos;